
  import { css } from 'lit';
  export const styles = css`:host{--background-color: var(--ig-badge-background-color, var(--ig-primary-800));--dot-size: var(--ig-badge-dot-size, max(var(--is-large, 1) * max(0.75rem, -1 * 0.75rem), var(--is-medium, 1) * max(0.625rem, -1 * 0.625rem), var(--is-small, 1) * max(0.5rem, -1 * 0.5rem)));--ig-theme: material;--ig-theme-variant: dark}`;
  